import { createContext, useContext, useEffect, useState } from 'react';
import api from '../utils/api';
import { logoutAction } from '../utils/action';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [authUser, setAuthUser] = useState(() => {
    const storedUser = localStorage.getItem('authUser');
    return storedUser ? JSON.parse(storedUser) : null;
  });

  const [loading, setLoading] = useState(!authUser);

  const preloadUser = async () => {
    try {
      const data = await api.getOwnProfile();
      setAuthUser(data);
      localStorage.setItem('authUser', JSON.stringify(data));
    } catch {
      setAuthUser(null);
      localStorage.removeItem('authUser');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!authUser) {
      preloadUser();
    }
  }, []);

  const signOut = () => {
    logoutAction();
    setAuthUser(null);
    localStorage.removeItem('authUser');
  };

  return (
    <AuthContext.Provider value={{ authUser, setAuthUser, signOut, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
